import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import { connect, Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { merge, clone, get, remove, pullAt, concat, at } from 'lodash';
// import heic2any from 'heic2any';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { Button, List, Modal, message, Icon, Switch, InputItem, Toast, TextareaItem, ImagePicker, Checkbox } from 'antd-mobile';
import { TextDialog } from '../../../components/textDialog';
import { ShareBtn } from '../../../components/icons/share';
import { BackBtn } from '../../../components/icons/back';
import { actionCopyrightUpload } from '../../commonAction';
import { Vh5Bar } from '../../../components/bar';
import { VDialogText } from '../../../components/dialog';
import { Vh5Tags } from '../../../components/tags';
import { Vh5Search } from '../../../components/search';
import { Loading } from '../../../components/loading';
import { Vh5UppyUpload } from '../../../components/uppyUpload';
import { EditSingleImg } from './editDialog';
import { base64ToBlob, blobToDataURL, blobToFile, readCookie, createCookie } from '../../../utils/common';
import { getWeixinConfig, configWeixin } from '../../../utils/weixin';
import { filterCallback, getCityList, putImgInfo, getActivityDetail, getUploadToken, getRedisKey } from './action';
import { _track } from '../../../utils/track';
import AWS from 'aws-sdk';
import AwsS3Multipart from '@uppy/aws-s3-multipart';
import './index.scss';
let uppyObject = null;
const mapStateToProps = state => {
	return {
		cityList: state.CopyrightBaseinfoReducers.cityList,
		baseInfo: state.CopyrightBaseinfoReducers.baseinfo,
		detail: state.CopyrightActivityReducers.detail,
		awss3Token: state.CopyrightBaseinfoReducers.awss3Token
	};
};
let uppy = null,
	globalAwss3Token = {},
	localaws = null;
function fnAWS() {
	if (!localaws) {
		AWS.config.update({
			region: globalAwss3Token.bucket,
			credentials: new AWS.CognitoIdentityCredentials({
				IdentityPoolId: 'www'
			})
		});
		localaws = new AWS.S3({
			...globalAwss3Token,
			apiVersion: '2020-03-16',
			s3BucketEndpoint: false
		});
	}
	return localaws;
}
function CopyrightUpload(props) {
	let history = useHistory();
	const mapState = useCallback(mapStateToProps, []);
	const AgreeItem = Checkbox.AgreeItem;
	const { cityList, baseInfo = {}, detail = {}, awss3Token = {} } = useMappedState(mapState);
	let dispatch = useDispatch();
	let params = useParams();
	let token = readCookie('userToken');
	let userId = readCookie('copyrightuserId');
	let { avatar } = baseInfo;
	const [pageData, setPageData] = useState({
		des: '',
		files: []
	});
	let [newInfo, setNewInfo] = useState({
		cityName: {
			value: '',
			beat: 0
		},
		city: {
			value: '',
			beat: 0
		}, //拼音
		original: {
			value: true,
			beat: 0
		}
	});
	
	//topicId_xxqg根据环境不同，修改成不同的主题ID(学习强国)
	//uat-1：601a616f50c46b0008d8a424
	//prod：600ff2c6ce11ce00076a7b6b
	let topicId_xxqg = '600ff2c6ce11ce00076a7b6b';
	
	const [effectFlag, setEffectFlag] = useState(1);
	const [showSearch, setShowSearch] = useState(false);
	const [showTags, setShowTags] = useState(false);
	const [cityValue, setCityValue] = useState('');
	const [tagsValue, setTagsValue] = useState([]);
	const [redisImgKey, setRedisImgKey] = useState([]);
	const [isShowNotice, setShowNotice] = useState(false);
	const [showInstruction, setShowInstruction] = useState(false);
	const [btndisabled, setBtndisabled] = useState(params.id === topicId_xxqg ? true : false);
	const [showDialog, setShowDialog] = useState(false);
	const [curIndex, setCurIndex] = useState(1);
	const [loadingIndexArray, setLoadingIndexArray] = useState([]);
	const [showUppy, setShowUppy] = useState(false);
	const [showTips, setShowTips] = useState(false);
	const [showAgreement, setShowAgreement] = useState(false);
	// let name = decodeURIComponent(window.location.search).slice(1);
	
	function handleDesChange(val) {
		pageData.des = val;
		setPageData(clone(pageData));
	}
	useEffect(() => {
		if (effectFlag === 1) {
			setEffectFlag(2);
			dispatch(getActivityDetail({ topicId: params.id }));
			dispatch(getCityList());
			_track({
				trackName: 'toutu_upload_page',
				payload: {
					page_action_name: 'upload-init-citylist'
				}
			});
			dispatch(
				getWeixinConfig({ url: window.location.href }, data => {
					console.log('getWeixinConfig', data);
					configWeixin(data, {
						title: '投图',
						desc: '主题影像即时创作平台',
						toPage: `activity/${params.id}`
					});
				})
			);
		}
	}, [dispatch, params, effectFlag]);
	function uploadImage() {
		let uploadRedis = [];
		let keys = pageData.files.map(o => o.key);
		for (let i = 0, j = keys.length; i < j; i++) {
			uploadRedis.push({
				description: pageData.files[i].textArea || '',
				key: keys[i]
			});
		}
		let payload = {
			description: pageData.des || '',
			uploadRedis,
			type: params.uploadType === '1' ? 2 : 1,
			topicId: params.id,
			city: newInfo.city.value,
			cityName: newInfo.cityName.value,
			userId,
			isOriginal: newInfo.original.value ? 20 : 10,
			tags: tagsValue
		};
		dispatch(
			putImgInfo(
				payload,
				data => {
					Toast.hide();
					console.log('data...', data);
					Toast.success('提交照片成功');
					_track({
						trackName: 'toutu_upload_page',
						payload: {
							uploadType: payload.type === 1 ? '图片' : '视频',
							uploadLength: uploadRedis.length,
							page_action_name: 'upload-save-img-message'
						}
					});
					history.push({
						pathname: '/vpmobile/copyright/ucenter'
					});
				},
				data => {
					Toast.hide();
					console.log('data...', data);
					Toast.fail('提交失败');
				}
			)
		);
	}
	function uploadPhoto() {
		_track({
			trackName: 'toutu_upload_page',
			payload: {
				Upload_Action: '我已了解并继续'
			}
		});
		setShowInstruction(false);
		Toast.loading('保存中...', 2000, () => {}, true);
		uploadImage();
	}
	function validateAndTip() {
		const OPTIONAL_KEYS = ['description'];
		let keys = pageData.files.map(o => o.key);
		console.log('keys...', keys);
		let payload = {
			description: pageData.des || '',
			redisKey: keys, //redisImgKey,
			topicId: params.id,
			city: newInfo.city.value,
			cityName: newInfo.cityName.value,
			userId,
			isOriginal: newInfo.original.value ? 20 : 10,
			tags: tagsValue
		};
		for (let obj in payload) {
			if (!payload[obj] && !OPTIONAL_KEYS.includes(obj)) {
				if (obj === 'redisKey') {
					Toast.info('请上传图片');
					return;
				} else if (obj === 'city') {
					Toast.info('请填写拍摄地点');
					return;
				}
				Toast.info('请输入完整信息');
				return;
			} else if (obj === 'redisKey' && (!payload[obj] || !payload[obj].length)) {
				Toast.info('请上传图片');
				return;
			}
		}
		if (params.id === topicId_xxqg) {
			uploadPhoto();
		} else {
			setShowInstruction(true);
		}
	}
	let newCityName = newInfo.cityName.beat ? newInfo.cityName.value : baseInfo.cityName;
	function onBlurForIOS() {
		setTimeout(() => {
			window.scrollTo(0, 0);
		});
	}
	function toggleCopyrightNotice() {
		if (isShowNotice) {
			_track({
				trackName: 'toutu_upload_page',
				payload: {
					Upload_Action: '原创声明关闭'
				}
			});
		} else {
			_track({
				trackName: 'toutu_upload_page',
				payload: {
					Upload_Action: '原创声明打开'
				}
			});
		}
		setShowNotice(!isShowNotice);
	}
	function CopyrightNotice() {
		let text = `
			<p>为更好地服务与推动中国图片市场和文化创意产业的健康发展，呼吁社会各界尊重原创作者的劳动成果，制止非法图片转载行为或其他图片版权侵权行为，共同维护和促进国内图片版权市场的健康有序及可持续发展，投图在此郑重声明如下：</p>
			<p>1. 疫情期间图片使用均为公益免费；</p>
			<p>2. 用于文章配图，请务必注明“图片来源：VPHOTO投图 摄影师 XXX”；</p>
			<p>3. 用于其他渠道单独使用，如banner图、H5配图、APP内等，请于明显、恰当位置（图片角标、专题内页等）注明“图片来源：VPHOTO投图 摄影师 XXX”；</p>
			<p>4. 图片使用包括但不限于媒体文章配图页面、媒体各对外渠道配图、媒体相关微博、此主题相关新闻稿件报道等等，不得将图片用于一切涉及恶意攻击、谩骂及煽动诋毁性用途。</p>
			<p>5. 如因使用图片对上传者、照片中人物或涉及品牌等、VPHOTO、投图、相关征集方造成肖像权、名誉权、著作权等法律责任和相关损失，将由使用者全部承担；</p>
			<p>6. 本次征集最终解释权归投图所有。</p>
		`;
		return <TextDialog title="版权声明" footer="确定" clickFooter={toggleCopyrightNotice} text={text} />;
	}
	function instructionTextDialog() {
		let instruction = `
		<p>1、投稿作品需选取色彩感情强烈、富有创意的摄影作品，内容须健康向上，无恶意攻击、谩骂及煽动诋毁性内容，无违法违规内容；</p>
		<p>2、作品允许恰当的修饰，对亮度、对比度、色调等方面适度调整，但谢绝合成作品；</p >
		<p>3、作品须为作者原创，上传者须拥有作品完整的著作权，并获得照片中所包含人物肖像权的使用许可及其它必要的许可，同时须保证上传的照片不侵犯任何第三人的著作权、肖像权、名誉权、隐私权、商标权、商号权及其他合法权益；作品涉及的肖像权、名誉权、著作权等法律责任均由上传者本人承担，征集发起方投图不承担由此引起的一切法律后果。</p >
		<p>4、作品一经上传，即视为作者授权同意所有上传图片由投图进行管理、使用或转授权他人使用，允许所有上传作品由投图进行展示、允许投图及媒体进行宣传、稿件配图等方式引用，包括但不限于投图平台各页面、VPHOTO微博、VPHOTO官方微信账号、媒体文章配图页面、媒体各对外渠道配图、媒体相关微博、此主题相关新闻稿件报道等等，并无须再另行通知或支付稿酬。</p >
		<p>5、本次投稿须知最终解释权归投图所有。</p>`;
		if (showInstruction) {
			return <TextDialog title="投稿须知和版权说明" footer="了解并继续" text={instruction} clickFooter={uploadPhoto} />;
		}
		
	}
	function onSetMessage(index) {
		document.getElementsByClassName('copyright-upload')[0].scrollTop = 0;
		setCurIndex(index);
		setShowDialog(true);
	}
	function onChangeOriginal(data) {
		let original = {
			value: data,
			beat: 1
		};
		newInfo.original = original;
		setNewInfo(clone(newInfo));
	}
	function onTriggerUppy() {
		dispatch(
			getUploadToken(null, data => {
				console.log('data....index', data);
				setShowUppy(true);
			})
		);
	}
	function successCallback(files = [], curSuccessFiles, _uppyObject) {
		console.log('success', files);
		let filesVo = [];
		for (let i = 0, j = files.length; i < j; i++) {
			let file = files[i];
			let { name, id, size, type, s3Multipart } = file;
			let obj = {
				bucket: awss3Token.bucket,
				etag: s3Multipart.parts[0].ETag,
				fileLength: size,
				fileType: type,
				originalFilename: name,
				ossFileKey: s3Multipart.key,
				ossType:2
			};
			filesVo.push(obj);
		}
		uppyObject = _uppyObject;
		dispatch(
			getRedisKey({ filesVo: JSON.stringify(filesVo) }, data => {
				console.log('redis upload', data.data);
				for (let i = 0, j = get(data, 'data.length', 0); i < j; i++) {
					_track({
						trackName: 'toutu_upload_page',
						payload: {
							upload_fileType: files[i].type,
							Upload_Action: '上传成功'
						}
					});
					console.log('files[i].fileType', files[i].type);
					if (files[i].type === 'image/jpeg') {
						data.data[i].url = files[i].preview;
					}
				}
				pageData.files = data.data;
				setPageData(clone(pageData));
				setShowUppy(false);
			})
		);
	}
	function Vh5AgreementDetail(prop) {
		return (
			<div style={{ position: 'fixed', top: '0', left: '50%', transform: 'translateX(-50%)', width: '100vw', maxWidth: '500px', height: '100vh', background: '#fff', zIndex: '111', fontSize: '14px', overflowY: 'auto' }}>
				<div style={{ position: 'fixed', top: '0', left: '0', width: '100vw', maxWidth: '500px', height: '49px', background: '#fff', borderBottom: '1px solid rgba(0,0,0,.05)' }}>
					<div onClick={closeAgreementDetail} style={{ position: 'absolute', top: '12px', left: '15px' }} className="back-btn">
						<i className="iconfont arrow" style={{ color: '#000' }}>
							
						</i>
						<span style={{fontSize: '14px', fontWeight: 'bold'}}>返回</span>
					</div>
					<div style={{textAlign: 'center', padding: '15px', fontWeight: 'bold'}}>全家福公益拍摄版权协议</div>
				</div>
				<div style={{ marginTop: '49px', padding: '20px', lineHeight: '22px' }}>
					<div style={{fontWeight: 'bold'}}>对本人为贵司供稿的作品（以下统称“该作品”），本人承诺如下：</div>
					<div style={{paddingLeft: '20px'}}>
						<div style={{marginTop: '20px'}}>
							<span style={{marginLeft: '-20px', marginRight: '8px'}}>1.</span>
							<span>本人已获得该作品涉及的相关肖像权人的有效授权，贵司对作品的使用不会侵犯相关肖像权人的肖像权。</span>
						</div>
						<div style={{marginTop: '20px'}}>
							<span style={{marginLeft: '-20px', marginRight: '8px'}}>2.</span>
							<span>该作品由本人自行创作，不会侵犯任何第三方的著作权等合法权益，本人同意该作品的著作权等相关权益授权由贵司在VPHOTO平台或贵司合作的“学习强国”平台无偿使用。</span>
						</div>
						<div style={{marginTop: '20px'}}>
							<span style={{marginLeft: '-20px', marginRight: '8px'}}>3.</span>
							<span>本人承诺，该作品不存在以下任何情形：</span>
							<div style={{paddingLeft: '25px'}}>
								<div style={{marginTop: '10px'}}>
									<span style={{marginLeft: '-25px', marginRight: '8px'}}>(1)</span>
									<span>反对宪法所确定的基本原则的；</span>
								</div>
								<div style={{marginTop: '10px'}}>
									<span style={{marginLeft: '-25px', marginRight: '8px'}}>(2)</span>
									<span>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span>
								</div>
								<div style={{marginTop: '10px'}}>
									<span style={{marginLeft: '-25px', marginRight: '8px'}}>(3)</span>
									<span>损害国家荣誉和利益的；</span>
								</div>
								<div style={{marginTop: '10px'}}>
									<span style={{marginLeft: '-25px', marginRight: '8px'}}>(4)</span>
									<span>歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；</span>
								</div>
								<div style={{marginTop: '10px'}}>
									<span style={{marginLeft: '-25px', marginRight: '8px'}}>(5)</span>
									<span>宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；</span>
								</div>
								<div style={{marginTop: '10px'}}>
									<span style={{marginLeft: '-25px', marginRight: '8px'}}>(6)</span>
									<span>煽动民族仇恨、民族歧视，破坏民族团结的；</span>
								</div>
								<div style={{marginTop: '10px'}}>
									<span style={{marginLeft: '-25px', marginRight: '8px'}}>(7)</span>
									<span>破坏国家宗教政策，宣扬邪教和封建迷信的；</span>
								</div>
								<div style={{marginTop: '10px'}}>
									<span style={{marginLeft: '-25px', marginRight: '8px'}}>(8)</span>
									<span>散布谣言，扰乱经济秩序和社会秩序的；</span>
								</div>
								<div style={{marginTop: '10px'}}>
									<span style={{marginLeft: '-25px', marginRight: '8px'}}>(9)</span>
									<span>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span>
								</div>
								<div style={{marginTop: '10px'}}>
									<span style={{marginLeft: '-33px', marginRight: '8px'}}>(10)</span>
									<span>侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；</span>
								</div>
								<div style={{marginTop: '10px'}}>
									<span style={{marginLeft: '-33px', marginRight: '8px'}}>(11)</span>
									<span>法律、行政法规禁止的其他内容。</span>
								</div>
							</div>
						</div>
						<div style={{marginTop: '20px'}}>
							<span style={{marginLeft: '-20px', marginRight: '8px'}}>4.</span>
							<span>如有违上述承诺，一切损失及后果由本人承担。</span>
						</div>
					</div>
					<div style={{marginTop: '20px'}}>特此承诺！</div>
				</div>
			</div>
		);
	}
	function closeAgreementDetail() {
		setShowAgreement(false)
	}
	function fnDeleteFile(item, index) {
		console.log(uppyObject, item);
		if (uppyObject && uppyObject.removeFile) {
			console.log('item.key', item.key);
			uppyObject.removeFile(uppyObject.getFiles()[index].id);
			console.log('getFiles...', uppyObject.getFiles());
		}
		pullAt(pageData.files, index);
		setPageData(clone(pageData));
		_track({
			trackName: 'toutu_upload_page',
			payload: {
				Upload_Action: '删除图片'
			}
		});
	}
	let barConfig = {
		barContentText: params.uploadType === '1' ? '上传视频' : '上传图片',
		backCallback: () => {
			fnAWS().abortMultipartUpload();
			if (params.id === '0') {
				history.push({
					pathname: '/vpmobile/copyright/home'
				});
			} else {
				history.push({
					pathname: '/vpmobile/copyright/activity/' + params.id
				});
			}
		},
		saveCallback: () => {}
	};
	return (
		<Fragment>
			<div className={'copyright copyright-upload' + (showDialog ? ' noscroll' : '')}>
				{!showDialog ? (
					<div>
						<Vh5Bar {...barConfig} />
						<div
							className="upload-tips"
							onClick={() => {
								setShowTips(true);
							}}>
							<i className="info">&#xe654;</i>
							<span>小贴士</span>
						</div>
						<TextareaItem
							className="textarea-img"
							value={pageData.des}
							placeholder="请描述创作背景、故事、或思考…"
							prefixListCls="photo-des"
							onChange={handleDesChange}
							onBlur={onBlurForIOS}
							maxLength={140}
						/>
						<div className="textarea-len">{get(pageData, 'des.length', '0')}/140</div>
						<ul className="upload-preview">
							{pageData.files.map((item, index) => {
								let { url, textArea, key } = item;
								return (
									<li key={'preview-img-' + index} style={{ backgroundImage: `url(${url})` }}>
										<i
											className="delete-icon"
											onClick={() => {
												fnDeleteFile(item, index);
											}}>
											&#xe652;
										</i>
										{params.uploadType !== '1' ? (
											Boolean(textArea) ? (
												<i className="edit-icon" onClick={onSetMessage.bind(this, index)} key={'icon-' + index}>
													&#xe666;
												</i>
											) : (
												<i className="edit-icon" onClick={onSetMessage.bind(this, index)} key={'icon-' + index}>
													&#xe664;
												</i>
											)
										) : (
											''
										)}
									</li>
								);
							})}
							{(params.uploadType === '0' && pageData.files.length !== 9) || (params.uploadType === '1' && pageData.files.length < 1) ? (
								<li id="J_btn" className="open-uppy" onClick={onTriggerUppy}>
									<div className="plus-wrap">
										<Icon type="plus" />
									</div>
									<div className="text">
										{params.uploadType === '0' ? `原图上传` : `MP4、MOV格式`}
										<br />
										{params.uploadType === '0' ? '支持JP(E)G/HEIC格式' : '建议大小200M以内'}
									</div>
								</li>
							) : (
								''
							)}
							{get(pageData, 'files.length', 0) % 3 === 1 ? <li style={{ visibility: 'hidden' }}>&nbsp;</li> : ''}
						</ul>
						{get(detail, 'name', '') ? (
							<div className="sport-name">
								<i>&#xe65f;</i>
								{detail.name}
							</div>
						) : (
							''
						)}
						{get(detail, 'tags.length', 0) ? (
							<div className="activity-tags">
								{detail.tags &&
									detail.tags.map((item, index) => {
										return (
											<span key={'activity-tags' + index}>
												<i>&#xe65f;</i>
												{item}
											</span>
										);
									})}
							</div>
						) : (
							''
						)}
						<div className="tags item">
							<span className="item-title">添加标签</span>
							<span
								onClick={() => {
									setShowTags(true);
									_track({
										trackName: 'toutu_upload_page',
										payload: {
											Upload_Action: '添加标签'
										}
									});
								}}>
								<div className="tags-text">
									<span className="tags-value" style={{ float: 'left' }}>
										{tagsValue.join(',')}
									</span>
									<span className="item-arrow" style={{ float: 'right' }}>
										<i>&#xe655;</i>
									</span>
								</div>
							</span>
						</div>
						<div className="location item">
							<span className="item-title">拍摄地点</span>
							<span
								onClick={() => {
									setShowSearch(true);
									_track({
										trackName: 'toutu_upload_page',
										payload: {
											Upload_Action: '拍摄地点'
										}
									});
								}}>
								<div className="city-text">
									{newCityName ? (
										<span style={{ float: 'left' }}>{newCityName}</span>
									) : (
										<span style={{ float: 'left', marginTop: '-3px' }}>
											<i>&#xe65e;</i>拍摄城市
										</span>
									)}
									<span className="item-arrow" style={{ float: 'right' }}>
										<i>&#xe655;</i>
									</span>
								</div>
							</span>
						</div>
						{params.id !== topicId_xxqg ? (
							<div className="copyright item last-item">
								<span className="item-title">版权声明</span>
								<div className="right">
									<span className="original-text">{newInfo.original.value ? '原创' : '非原创'}</span>
									<Switch checked={newInfo.original.value} color="#007AFF" className="switch-right" onChange={onChangeOriginal} />
								</div>
							</div>
						) : ('')}
						{params.id === topicId_xxqg ? (
								<div style={{position: 'relative', top: '0', height: '50px', borderTop: '1px solid rgba(0, 0, 0, 0.1)'}}>
									<AgreeItem data-seed="logId" style={{marginLeft: '0'}} onChange={e=>{
										setBtndisabled(!e.target.checked);
									}}></AgreeItem>
									<span style={{position: 'absolute', top: '11px', left: '30px', fontSize: '14px', textDecoration: 'underline', cursor: 'pointer'}}
									  onClick={() => {
									  	setShowAgreement(true);
									  }}>我已阅读并接受全家福公益拍摄版权协议</span>
								</div>
							) : (
								newInfo.original.value ? (
									<div className="original-wrap">
										<div className="notice">
											<i className="info">&#xe654;</i>为了保护版权原创，投图平台将验证版权，如有他人申诉或发生侵权行为图片将改为非原创
										</div>
										<div className="original-row">作品中将会展示如下信息</div>
										<div className="original-row">
											作者署名{avatar ? <i className="avatar" style={{ background: `url(${avatar})` }}></i> : <i className="head">&#xe64f;</i>}
											{baseInfo.nickname}
										</div>
										<div className="original-row" onClick={toggleCopyrightNotice}>
											原创认证<i className="origin">&#xe660;</i>
											<span className="o-text">原创</span>
										</div>
									</div>
								) : (
									''
								)
							)
						}
						<Button
							type="primary"
							className="upload-btn"
							onClick={() => {
								if (btndisabled) {
									Toast.info('请勾选版权协议后提交');
								} else {
									validateAndTip();
									_track({
										trackName: 'toutu_upload_page',
										payload: {
											Upload_Action: '立即提交'
										}
									});
								}
							}}>
							立即提交
						</Button>
					</div>
				) : (
					<EditSingleImg
						files={pageData.files}
						index={curIndex}
						backCallback={() => {
							setShowDialog(false);
						}}
						saveCallback={files => {
							pageData.files = files;
							setPageData(clone(pageData));
						}}
					/>
				)}
			</div>
			{showTags ? (
				<Vh5Tags
					tagsKey="activity-tags"
					tagsData={detail.tags}
					selectedTags={tagsValue}
					saveCallback={v => {
						setTagsValue(v);
						setShowTags(false);
					}}
					filterCallback={filterCallback}
					onClose={() => setShowTags(false)}
				/>
			) : (
				''
			)}
			{showSearch ? (
				<Vh5Search
					searchKey="baseinfo-city"
					searchData={cityList}
					placeholder="搜索城市"
					searchCallback={v => {
						setCityValue(v);
						newInfo['cityName'] = {
							value: v,
							beat: 1
						};
						let code = '';
						for (let i = 0, j = cityList.length; i < j; i++) {
							let val = cityList[i];
							if (val.indexOf(v) >= 0) {
								code = val.split('|')[1];
								break;
							}
						}
						newInfo['city'] = {
							value: code,
							beat: 1
						};
						setNewInfo(clone(newInfo));
						setShowSearch(false);
					}}
					filterCallback={filterCallback}
					onClose={() => setShowSearch(false)}
				/>
			) : (
				''
			)}
			{showTips ? (
				<VDialogText
					className="dialog-text"
					show={true}
					title={'小贴士'}
					comfirmtext={'我知道了'}
					callback={() => {
						setShowTips(false);
					}}>
					<div className="black-tip" style={{ textAlign: 'left', overflow: 'auto', fontSize: '14px' }}>
						<span style={{ fontSize: '16px', fontWeight: 'blod' }}>基础指标</span>
						<br />
						<br />
						1. 曝光正常(保留亮部跟暗部细节在合理的范围,剪影或过曝等创作手法不在此限)
						<br />
						<br />
						2. 对焦正确(至少主体要清晰避免模糊，模糊创作需要有内容明确表达感知度)
						<br />
						<br />
						3. 构图需要合理，准许后期裁切，凸显主旨，避免太多视觉干扰的物件在画面里
						<br />
						<br />
						4. 合理运用焦段，避免不恰当过分变形
						<br />
						<br />
						5. 主题需明确，避免画面內容沒有重点，否则即使经过修片也很难使用
						<br />
						<br />
						6. 照片内容避免跟图片解说或是招募主题关联性低
						<br />
						<br />
						7. 若前期生图不太理想， 图片最好经过后期调色或裁切再上传，(图片要在媒体可以直接使用的基础上传)
						<br />
						<br />
						8. 避免上传敏感内容(色情,违反社会道德观念,血腥)
						<br />
						<br />
						9. 內容需要经过一定思考，避免让媒体产生反感，避免上传太多重复近似的照片
						<br />
						<br />
						10. 所有上传照片不可出现任何私人水印标记
					</div>
				</VDialogText>
			) : (
				''
			)}
			{isShowNotice ? <CopyrightNotice /> : ''}
			{showAgreement ? <Vh5AgreementDetail /> : ''}
			{instructionTextDialog()}
			{awss3Token && awss3Token.hasOwnProperty('uploadPath') ? (
				<Vh5UppyUpload awss3Token={awss3Token} showUppy={showUppy} setShowUppy={setShowUppy} successCallback={successCallback} uploadType={params.uploadType} />
			) : (
				''
			)}
		</Fragment>
	);
}
export { CopyrightUpload };
